<template>
    <v-container fluid>   
      <LeftMenu/>     

      <v-tabs
          v-model="tab"
          fixed-tabs          
          background-color="white"
          color="black accent-4"
          left
        >
          <v-tab key="masterCategory">
            Material Master Categories
          </v-tab>
          <v-tab key="category">
            Material  Categories
          </v-tab>   
          <v-tab key="material">
            Materials
          </v-tab>         
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            key="masterCategory"
          >
            <v-layout row wrap>   
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersMaster"
                  :items="masterCategories"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="id"
                  :sort-desc=true
                  class="elevation-1"
                  :search="searchMasterCategory"
                  :custom-filter="filterOnlyCapsTextMaster"
                  @dblclick:row="editMasterItem"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Material Master Category</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogMasterCategory" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Master Category</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitleMaster }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedMasterItem.code" label="Code"></v-text-field>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedMasterItem.text" label="Text"></v-text-field>
                                </v-flex>                                                                                                                                                                            
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeMasterDialog">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="saveMasterCategory">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="searchMasterCategory" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>             
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editMasterItem(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteMasterItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item
            key="category"
          >
            <v-layout row wrap>   
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersCategory"
                  :items="categories"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="id"
                  :sort-desc=true
                  class="elevation-1"
                  :search="searchCategory"
                  :custom-filter="filterOnlyCapsText"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Material Categories</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogCategory" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Category</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md12>
                                  <v-combobox
                                    :items="masterCategories"
                                    label="Master"
                                    v-model="editedItem.masterCategory"
                                    item-text="text"
                                    single-line
                                    return-object
                                  ></v-combobox>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.code" label="Code"></v-text-field>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.text" label="Text"></v-text-field>
                                </v-flex>                                                                                                                                                                                               
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeDialog">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="saveCategory">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="searchCategory" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>             
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editItem(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item
            key="material"
          >
            <v-layout row wrap>   
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersMaterial"
                  :items="materials"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="id"
                  :sort-desc=true
                  class="elevation-1"
                  :search="searchMaterial"
                  :custom-filter="filterOnlyCapsTextSub"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Materials</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogMaterial" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Material</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitleSub }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md16>
                                  <v-combobox
                                    :items="categoriesFormatted"
                                    label="Category"
                                    v-model="editedMaterial.category"
                                    item-text="text"
                                    single-line
                                    return-object
                                  ></v-combobox>
                                </v-flex> 
                                <v-flex xs12 sm6 md2>
                                  <v-text-field v-model="editedMaterial.code" label="Code"></v-text-field>
                                </v-flex> 
                                <v-flex xs6 sm6 md2>
                                  <v-combobox
                                    :items="units"
                                    label="Select Unit"
                                    v-model="editedMaterial.unit"
                                    item-text="text"
                                    single-line
                                    return-object
                                  ></v-combobox>
                                </v-flex>  
                                <v-flex xs12 sm6 md2>
                                  <v-text-field v-model="editedMaterial.criticalLevel" label="Critical Level"></v-text-field>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedMaterial.text" label="Inovenso Name"></v-text-field>
                                </v-flex>         
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedMaterial.industryText" label="Industry Name"></v-text-field>
                                </v-flex>                                                                                                                                                                                  
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeMaterialDialog">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="saveMaterial">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="searchMaterial" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>             
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editMaterial(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteMaterial(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>

        </v-tabs-items>  
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const MASTER_API_URL = 'definitions/materialMasterCategories';
const API_URL = 'definitions/materialCategories';
const SUB_API_URL = 'definitions/materials';
const UNITS_URL = 'definitions/materialUnits';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {
      tab: null,
      dialogMasterCategory: false,
      dialogCategory: false,
      dialogMaterial: false,
      searchMasterCategory: '',
      searchCategory: '',
      searchMaterial: '',
      masterCategories: [],
      units: [],
      categories: [  ],
      materials: [  ],
      formTitleMaster: 'New Master Category',
      formTitle: 'New  Category',
      formTitleSub: 'New Material',
      editedMasterIndex: -1,
      editedIndex: -1,
      editedSubIndex: -1,
      editedMasterItem: { },
      editedItem: { },
      editedMaterial: { },
      defaultItem: {},
    }
  },
  computed: {
    headersMaster () {
      return [
        { text: 'Code', align: 'left', sortable: true, value: 'code'},
        { text: 'Text',  value: 'text'  }, 
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    headersCategory () {
      return [
        { text: 'Master Category', align: 'left', sortable: true, value: 'masterCategory.text'},
        { text: 'Code', align: 'left', sortable: true, value: 'code'},
        { text: 'Text',  value: 'text'  }, 
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    headersMaterial () {
      return [
        { text: 'Category', align: 'left', sortable: true, value: 'materialName'},
        { text: 'Code', align: 'left', sortable: true, value: 'code'},
        { text: 'Unit', align: 'left', sortable: true, value: 'unit.text'},
        { text: 'Critical Level', align: 'left', sortable: true, value: 'criticalLevel'},
        { text: 'Inovenso Name',  value: 'text'  }, 
        { text: 'Industry Name',  value: 'industryText'  }, 
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    categoriesFormatted(){
      return this.categories.map((item) => {
        if(item.masterCategory){
          item.textFormatted = item.masterCategory.text +' - '+ item.text;
        }
        return item;  
      })
    },
  },
  created() {    
    this.getMasterCategories();   
    this.getCategories();
    this.getMaterials(); 
    this.getMaterialUnits();
  },
  watch: {
    dialogMasterCategory (val) {
      val || this.closeMasterDialog()
    },
    dialogCategory (val) {
      val || this.closeDialog()
    },
    dialogMaterial (val) {
      val || this.closeMaterialDialog()
    },
  },
  methods: {
    editMasterItem (item) {
      this.editedMasterIndex = this.masterCategories.indexOf(item)
      this.editedMasterItem = Object.assign({}, item)
      this.formTitleMaster = 'Edit Master Category';
      this.dialogMasterCategory = true
    },

    deleteMasterItem (item) {
      const index = this.masterCategories.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.masterCategories.splice(index, 1);
        this.deleteMasterCategory(item);
      } 
    },

    editItem (item) {
      this.editedIndex = this.categories.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.formTitle = 'Edit Category';
      this.dialogCategory = true
    },

    deleteItem (item) {
      const index = this.categories.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.categories.splice(index, 1);
        this.deleteCategory(item);
      } 
    },

    editMaterial (item) {
      console.log(item);
      this.editedSubIndex = this.materials.indexOf(item)
      this.editedMaterial = Object.assign({}, item)
      this.formTitleSub = 'Edit Material';
      this.dialogMaterial = true
    },

    deleteMaterial (item) {
      const index = this.materials.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.materials.splice(index, 1);
        this.deleteMaterial(item);
      } 
    },
    closeMasterDialog () {
      this.dialogMasterCategory = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedMasterIndex = -1
      }, 300)
    },
    closeDialog () {
      this.dialogCategory = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    closeMaterialDialog () {
      this.dialogMaterial = false
      setTimeout(() => {
        this.editedMaterial = Object.assign({}, this.defaultItem)
        this.editedSubIndex = -1
      }, 300)
    },

    saveMasterCategory () {
      if (this.editedMasterIndex > -1) {        
        this.updateMasterCategory(this.editedMasterItem);
      } else {
        this.addMasterCategory(this.editedMasterItem);         
      }      
    },
    saveCategory () {
      if (this.editedIndex > -1) {        
        this.updateCategory(this.editedItem);
      } else {
        this.addCategory(this.editedItem);         
      }      
    },
    saveMaterial () {
      if (this.editedSubIndex > -1) {        
        this.updateMaterial(this.editedMaterial);
      } else {
        this.addMaterial(this.editedMaterial);         
      }      
    },
    addMasterCategory(item){
      this.$axios.post(this.$apiurl + MASTER_API_URL, {
        code: item.code,
        text: item.text
      })
      .then(response => {        
        if (response.status === 201) {
          this.masterCategories.push(this.editedMasterItem);
          this.$radio.$emit('success', {message:'Master Category Added Successfully'});
          this.closeMasterDialog();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateMasterCategory(item){
      this.$axios.put(this.$apiurl + MASTER_API_URL, {
        id: item.id,
        code: item.code,
        text: item.text
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.masterCategories[this.editedMasterIndex], this.editedMasterItem);
          this.$radio.$emit('success', {message:'Master Category Updated Successfully'});
          this.closeMasterDialog();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteMasterCategory(item){
      this.$axios.delete(this.$apiurl + MASTER_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getMasterCategories(){     
      this.$axios.get(this.$apiurl + MASTER_API_URL)
        .then(response => {
            this.masterCategories = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    addCategory(item){
      console.log(item);
      this.$axios.post(this.$apiurl + API_URL, {
        masterId : item.masterCategory.id,
        code: item.code,
        text: item.text
      })
      .then(response => {        
        if (response.status === 201) {
          this.categories.push(this.editedItem);
          this.$radio.$emit('success', {message:'Category Added Successfully'});
          this.closeDialog();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateCategory(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        masterId : item.masterCategory.id,
        code: item.code,
        text: item.text
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.categories[this.editedIndex], this.editedItem);
          this.$radio.$emit('success', {message:'Category Updated Successfully'});
          this.closeDialog();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteCategory(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getCategories(){     
      this.$axios.get(this.$apiurl + API_URL)
        .then(response => {
            this.categories = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    addMaterial(item){
      this.$axios.post(this.$apiurl + SUB_API_URL, {
        categoryId : item.category.id,
        code: item.code,
        text: item.text,
        criticalLevel: item.criticalLevel,
        unitId: item.unit ? item.unit.id : null,
        industryText: item.industryText
      })
      .then(response => {        
        if (response.status === 201) {
          this.materials.push(this.editedMaterial);
          this.$radio.$emit('success', {message:'Material Added Successfully'});
          this.closeMaterialDialog();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateMaterial(item){
      this.$axios.put(this.$apiurl + SUB_API_URL, {
        id: item.id,
        categoryId : item.category.id,
        code: item.code,
        unitId: item.unit ? item.unit.id : null,
        criticalLevel: item.criticalLevel,
        text: item.text,
        industryText: item.industryText
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.materials[this.editedSubIndex], this.editedMaterial);
          this.$radio.$emit('success', {message:'Material Updated Successfully'});
          this.closeMaterialDialog();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteMaterial(item){
      this.$axios.delete(this.$apiurl + SUB_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getMaterials(){     
      this.$axios.get(this.$apiurl + SUB_API_URL)
        .then(response => {
            this.materials = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    getMaterialUnits(){     
        this.$axios.get(this.$apiurl + UNITS_URL)
            .then(response => {
                this.units = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsTextMaster (value, searchMasterCategory) {
      return value != null &&
        searchMasterCategory != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(searchMasterCategory.toLocaleUpperCase()) !== -1
    },
    filterOnlyCapsText (value, searchCategory) {
      return value != null &&
        searchCategory != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(searchCategory.toLocaleUpperCase()) !== -1
    },
    filterOnlyCapsTextSub (value, searchMaterial) {
      return value != null &&
        searchMaterial != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(searchMaterial.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
